// eslint-disable-next-line
export default {
    isDebug: false,
    api_server: "/api",
    socket_server: "/",
    app_storage_prefix: "kda-awards__prod",
    hCaptchaToken: "840eedad-5f88-46c7-b24b-3cb9756cc69c"
}